import { render, staticRenderFns } from "./addAuthorization.vue?vue&type=template&id=4b4e7a72&scoped=true"
import script from "./addAuthorization.vue?vue&type=script&lang=js"
export * from "./addAuthorization.vue?vue&type=script&lang=js"
import style0 from "./addAuthorization.vue?vue&type=style&index=0&id=4b4e7a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e7a72",
  null
  
)

export default component.exports